module.exports = __webpack_public_path__ + "media/match-pair.5bfeb1ba.webm";